/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_RolesInputs */

const de__field_roles = /** @type {(inputs: _Field_RolesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rollen im Permissionsystem`)
};

/**

* @param {_Field_RolesInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_roles = /** @type {((inputs?: _Field_RolesInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_RolesInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_roles(inputs)
});